import * as actions from '../actions/signinOrRegisterDialog'

const initialState = {
  isPopupOpened: false,
  tabId: 'signIn' // | "createAccount"
}
const signinOrRegisterDialog = (state = initialState, action) => {
  switch (action.type) {
    case actions.OPEN_SIGNIN_DIALOG:
      return {
        ...state,
        isPopupOpened: true,
        tabId: action.tabId
      }

    case actions.CLOSE_SIGNIN_DIALOG:
      return {
        ...state,
        isPopupOpened: false
      }

    case actions.OPEN_SIGNIN_DIALOG_TAB_CLICK:
      return {
        ...state,
        tabId: action.tabId
      }

    default:
      return state
  }
}

export default signinOrRegisterDialog
